import { breakpoints } from '../constants'

export type BreakpointName = keyof typeof breakpoints

export const mediaBreakpointGte = (breakpoint: BreakpointName) => {
  return `@media (min-width: ${breakpoints[breakpoint]}px)`
}
